// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Restaumatic_Money from "../Restaumatic.Money/index.js";
var unwrapComposeFlipped = function () {
    return function (a) {
        return function (b) {
            var $13 = Data_Newtype.unwrap();
            return function ($14) {
                return b($13(a($14)));
            };
        };
    };
};
var unsafeFromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var unsafeIndex = function (arr) {
    var $15 = Data_Array.index(arr);
    return function ($16) {
        return unsafeFromJust($15($16));
    };
};
var splitListEvery = function (n) {
    return function (v) {
        if (v instanceof Data_List_Types.Nil) {
            return Data_List_Types.Nil.value;
        };
        var x = Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_List.take(n)(v));
        var $5 = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(x) === n;
        if ($5) {
            var xs = Data_List.drop(n)(v);
            return new Data_List_Types.Cons(x, splitListEvery(n)(xs));
        };
        return Data_List_Types.Nil.value;
    };
};
var splitEvery = function (nVal) {
    return function (array) {
        if (nVal < 1) {
            return [  ];
        };
        return Data_Array.fromFoldable(Data_List_Types.foldableList)(splitListEvery(nVal)(Data_Array.toUnfoldable(Data_List_Types.unfoldableList)(array)));
    };
};
var targetSourcesEvery = function (nVal) {
    return function (array) {
        if (nVal < 1) {
            return [  ];
        };
        var toTargetSource = function (arr) {
            return new Data_Tuple.Tuple(unsafeFromJust(Data_Array.last(arr)), Data_Maybe.fromMaybe([  ])(Data_Array.init(arr)));
        };
        return Data_Functor.map(Data_Functor.functorArray)(toTargetSource)(splitEvery(nVal)(array));
    };
};
var splitAt = function (num) {
    return function (arr) {
        return new Data_Tuple.Tuple(Data_Array.take(num)(arr), Data_Array.drop(num)(arr));
    };
};
var ppArray = function (dictShow) {
    return function (array) {
        var pArray = Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(",\x0a\x0a")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(dictShow))(array));
        return "[\x0a" + (pArray + "\x0a]");
    };
};
var partitionTuple = function (predicate) {
    return function (arr) {
        var toTuple = function (v) {
            return new Data_Tuple.Tuple(v.yes, v.no);
        };
        return toTuple(Data_Array.partition(predicate)(arr));
    };
};
var getW = function () {
    return function (o) {
        return function (acc) {
            return acc(Data_Newtype.unwrap()(o));
        };
    };
};
var fromW = function () {
    return Data_Function.flip(getW());
};
export {
    fromW,
    getW,
    partitionTuple,
    ppArray,
    splitAt,
    splitEvery,
    splitListEvery,
    targetSourcesEvery,
    unsafeFromJust,
    unsafeIndex,
    unwrapComposeFlipped
};
//# sourceMappingURL=index.js.map
